import api from 'src/app/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { buildEncodedQueryString } from 'src/common';
import {
  Afsl,
  AssetClassOrderItem,
  AssetClassOverrideItem,
  FetchAfslIdsResponse,
  FetchAssetClassOrderPayload,
  FetchAssetClassOverridePayload,
  UpsertAssetClassOrderPayload,
  UpsertAssetClassOverridePayload,
} from './types';

// --> AssetClass order enpoints start
export enum AssetClassOrderTypes {
  FetchAssetClassOrder = '@@templates/report-settings/FetchSortOrder',
  UpsertAssetClassOrder = '@@templates/report-settings/UpsertSortOrder',
  FetchAfsls = '@@client/securities/report-settings/FetchAsflIds',
}

export enum AssetClassOrderEndpoints {
  FetchAssetClassOrder = '/securities/GetAssetClassOrder',
  UpsertAssetClassOrder = '/securities/UpsertAssetClassOrder',
  FetchAfsls = '/bff/GetAfslsPracticesAdvisersForUser',
}

export const fetchAssetClassOrder = createAsyncThunk(AssetClassOrderTypes.FetchAssetClassOrder, async ({ afslId }: FetchAssetClassOrderPayload) => {
  const queryString = buildEncodedQueryString({
    afslId,
  });
  const response = await api.get<AssetClassOrderItem[]>(`${AssetClassOrderEndpoints.FetchAssetClassOrder}${queryString}`);
  return response.data;
});

export const upsertAssetClassOrder = createAsyncThunk(
  AssetClassOrderTypes.UpsertAssetClassOrder,
  async (payload: UpsertAssetClassOrderPayload, thunkApi) => {
    await api.post<number>(`${AssetClassOrderEndpoints.UpsertAssetClassOrder}`, payload);
    await thunkApi.dispatch(fetchAssetClassOrder({ afslId: payload.afslId }));
    return { message: 'Report AssetClass sort order is updated ...' };
  }
);
// <-- AssetClass order enpoints end

// --> AssetClass override enpoints start
export enum AssetClassOverrideTypes {
  FetchAssetClassOverride = '@@templates/report-settings/FetchOverride',
  UpsertAssetClassOverride = '@@templates/report-settings/UpsertOverride',
  FetchAfsls = '@@client/securities/report-settings/FetchAsflIds',
}

export enum AssetClassOverrideEndpoints {
  FetchAssetClassOverride = '/securities/GetAssetClassOverride',
  UpsertAssetClassOverride = '/securities/UpsertAssetClassOverride',
  FetchAfsls = '/bff/GetAfslsPracticesAdvisersForUser',
}

export const fetchAssetClassOverride = createAsyncThunk(
  AssetClassOverrideTypes.FetchAssetClassOverride,
  async ({ afslId }: FetchAssetClassOverridePayload) => {
    const queryString = buildEncodedQueryString({
      afslId,
    });
    const response = await api.get<AssetClassOverrideItem[]>(`${AssetClassOverrideEndpoints.FetchAssetClassOverride}${queryString}`);
    return response.data;
  }
);

export const upsertAssetClassOverride = createAsyncThunk(
  AssetClassOverrideTypes.UpsertAssetClassOverride,
  async (payload: UpsertAssetClassOverridePayload, thunkApi) => {
    await api.post<number>(`${AssetClassOverrideEndpoints.UpsertAssetClassOverride}`, payload);
    await thunkApi.dispatch(fetchAssetClassOverride({ afslId: payload.afslId }));
    return { message: 'Report AssetClass override is updated ...' };
  }
);
// <-- AssetClass override enpoints end

export const fetchAfsls = createAsyncThunk<Afsl[]>(AssetClassOrderTypes.FetchAfsls, async () => {
  const response = await api.get<FetchAfslIdsResponse>(AssetClassOrderEndpoints.FetchAfsls);
  return response.data.afsls.map((a) => ({ id: a.afslId, name: a.afslName }));
});
